export default __webpack_public_path__ + "static/media/5639371.f9648c6d.png";